<template>
  <main class="error-hero">
    <div class="error-content">
      <div class="error-number">
        4<span class="accent">0</span>4
      </div>
      <h1 class="error-title">{{ t('notFound.title') }}</h1>
      <p class="error-text" v-html="t('notFound.text')"></p>

      <router-link class="error-cta" :to="isEnglish ? '/en' : '/'">
        {{ t('notFound.cta') }}
        <span class="arrow" aria-hidden="true">&rarr;</span>
      </router-link>
    </div>
  </main>
</template>

<script setup>
import { useLocale } from '../composables/useLocale'

const { t, isEnglish } = useLocale()
</script>

<style scoped>
.error-hero {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 32px;
}
.error-content {
  max-width: 1120px;
  text-align: center;
}
.error-number {
  font-family: 'Fraunces', serif;
  font-weight: 800;
  font-size: clamp(120px, 22vw, 220px);
  line-height: 0.9;
  letter-spacing: -0.06em;
  color: var(--ink);
  margin-bottom: 16px;
}
.error-number .accent {
  background: var(--yellow);
  padding: 0 12px;
  border-radius: 8px;
  font-style: italic;
  display: inline-block;
  transform: rotate(-2deg);
}
.error-title {
  font-family: 'Fraunces', serif;
  font-weight: 800;
  font-size: clamp(32px, 5vw, 48px);
  line-height: 1.1;
  letter-spacing: -0.03em;
  color: var(--ink);
  margin-bottom: 18px;
  text-wrap: balance;
}
.error-text {
  font-size: 18px;
  color: var(--ink-soft);
  line-height: 1.55;
  margin-bottom: 36px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  text-wrap: pretty;
}
.error-cta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 17px;
  font-weight: 700;
  padding: 16px 28px;
  background: var(--blue);
  color: #fff;
  border-radius: 999px;
  text-decoration: none;
  transition: background 0.2s, transform 0.2s;
}
.error-cta:hover {
  background: var(--blue-dark);
  color: #fff;
  text-decoration: none;
  transform: translateY(-2px);
}
.error-cta .arrow {
  transition: transform 0.2s;
  display: inline-block;
}
.error-cta:hover .arrow { transform: translateX(4px); }
</style>
